import { Metamodel } from 'app/model/base/model';
import { StoreWriteSettings } from './store-write-settings';
import { AmazonS3LinkedService } from 'app/model/linkedservice/amazon-s3.linkedservice';

@Metamodel.model({
    name: 'AmazonS3WriteSettings',
    tags: {
        linkedServiceModel: Metamodel.modelFor(AmazonS3LinkedService)
    }
})
export class AmazonS3WriteSettings extends StoreWriteSettings {
}
